import React from "react";
import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Student } from "types/Student";
import Header from "./Header";
import { useNavigate } from "react-router-dom";

export interface StudentsGridProps {
  data: Array<Student> | undefined;
  isLoading: boolean;
  displayHeader: boolean;
}

export interface Age {
  years: number;
  months: number;
}

const StudentsGrid = ({
  data,
  isLoading,
  displayHeader,
}: StudentsGridProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleRowClick = (params: any) => {
    navigate(`/studentDetail/${params.id}`);
  };
  const calculateAge = (dobString: string): Age => {
    const dob = new Date(dobString);
    const now = new Date();

    let years = now.getFullYear() - dob.getFullYear();
    let months = now.getMonth() - dob.getMonth();

    // Adjust years and months if the current month is before the birth month
    if (months < 0) {
      years--;
      months += 12;
    }

    // Adjust months if the current day is before the birth day
    if (now.getDate() < dob.getDate()) {
      if (months === 0) {
        years--;
        months = 11;
      } else {
        months--;
      }
    }

    return { years, months };
  };
  const columns = [
    // { field: "id", headerName: "ID", flex: 0.5 },
    { field: "name", headerName: "Name", flex: 0.5 },
    {
      field: "aggregateData",
      headerName: "Screened",
      flex: 0.5,
      renderCell: (params: any) => {
        console.log(params.value);
        return params.value && params.value.length > 0 ? "Yes" : "No";
      },
    },
    { field: "class", headerName: "Class", flex: 0.5 },
    { field: "section", headerName: "Section", flex: 0.5 },
    { field: "gender", headerName: "Gender", flex: 0.5 },
    {
      field: "dateOfBirth",
      headerName: "Age",
      flex: 0.5,
      renderCell: (params: any) => {
        var age: Age = calculateAge(params.value as string);
        return `${age.years} years ${age.months} months`;
      },
    },
  ];
  return (
    <Box m="1.5rem 2.5rem">
      {displayHeader && <Header title="Students" subtitle="List of students" />}
      <Box
        mt="40px"
        height="75vph"
        // sx={{
        //   "& .MuiDataGrid-root": {
        //     border: "none",
        //   },
        //   "& .MuiDataGrid-cell": {
        //     borderBottom: "none",
        //   },
        //   "& .MuiDataGrid-columnHeaders": {
        //     backgroundColor: theme.palette.background.alt,
        //     color: theme.palette.secondary[100],
        //     borderBottom: "none",
        //   },
        //   "& .MuiDataGrid-virtualScroller": {
        //     backgroundColor: theme.palette.primary.light,
        //   },
        //   "& .MuiDataGrid-footerContainer": {
        //     backgroundColor: theme.palette.background.alt,
        //     color: theme.palette.secondary[100],
        //     boderTop: "none",
        //   },
        //   "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
        //     color: `${theme.palette.secondary[200]} !important`,
        //   },
        // }}
      >
        <DataGrid
          loading={isLoading || !data}
          rows={data || []}
          columns={columns}
          getRowId={(row) => row.id}
          onRowClick={handleRowClick}
        />
      </Box>
    </Box>
  );
};

export default StudentsGrid;
